import React, { useEffect, useState } from "react";

import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    TablePagination
} from "@mui/material";

import { useParams } from "react-router-dom";

import {
    collection,
    onSnapshot,
    query,
    where,
    orderBy
} from "firebase/firestore";

import { db } from "../../firebase";

function Customertrips() {

    const { customerId } = useParams();

    const [trips, setTrips] = useState([]);

    const [search, setSearch] = useState("");

    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(50);

    /* =====================================================
       FETCH CUSTOMER TRIPS
    ===================================================== */

    useEffect(() => {

        if (!customerId) return;

        const q = query(

            collection(db, "trips"),
            where("customerId", "==", customerId),
            orderBy("grossDate", "desc")
        );

        const unsub = onSnapshot(q, (snapshot) => {

            const data = snapshot.docs.map(doc => ({

                id: doc.id,

                ...doc.data()

            }));

            setTrips(data);

        });

        return () => unsub();

    }, [customerId]);

    /* =====================================================
       SEARCH FILTER
    ===================================================== */

    const filteredTrips = trips.filter((trip) =>
        JSON.stringify(trip)
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (

        <Box
            sx={{
                p: 2,
                bgcolor: "#f4f6f8",
                minHeight: "100vh",

                "& .MuiTableCell-root": {
                    fontSize: "13px",
                    padding: "6px"
                }
            }}
        >

            <Paper sx={{ p: 2 }}>

                {/* HEADER */}

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography variant="h6">

                        Customer Trips

                    </Typography>

                    <TextField
                        size="small"
                        label="Search"
                        value={search}
                        onChange={(e) =>
                            setSearch(e.target.value)
                        }
                    />

                </Box>

                {/* TABLE */}

                <TableContainer>

                    <Table size="small">

                        <TableHead>

                            <TableRow
                                sx={{
                                    background: "#f5f5f5"
                                }}
                            >

                                <TableCell>
                                    SR
                                </TableCell>

                                <TableCell>
                                    Challan No
                                </TableCell>

                                <TableCell>
                                    Customer
                                </TableCell>

                                <TableCell>
                                    Vehicle
                                </TableCell>

                                <TableCell>
                                    Product
                                </TableCell>

                                <TableCell align="center">
                                    Qty
                                </TableCell>

                                <TableCell>
                                    Total
                                </TableCell>

                                <TableCell>
                                    Paid
                                </TableCell>

                                <TableCell>
                                    Remaining
                                </TableCell>

                                <TableCell>
                                    Date
                                </TableCell>

                            </TableRow>

                        </TableHead>

                        <TableBody>

                            {filteredTrips
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => {

                                    const totalSale =
                                        row.products?.reduce(
                                            (sum, p) =>
                                                sum +
                                                (Number(p.amount) || 0),
                                            0
                                        ) || 0;

                                    return (

                                        <TableRow
                                            key={row.id}
                                            hover
                                        >

                                            <TableCell>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>

                                            <TableCell>
                                                {row.challan || "-"}
                                            </TableCell>

                                            <TableCell>
                                                {row.customerName}
                                            </TableCell>

                                            <TableCell>
                                                {row.vehicleNo}
                                            </TableCell>

                                            {/* PRODUCTS */}

                                            <TableCell>

                                                {row.products?.map((p, i) => (

                                                    <Typography
                                                        key={i}
                                                        sx={{
                                                            fontSize: "0.8rem"
                                                        }}
                                                    >

                                                        {i + 1}) {p.productName}

                                                    </Typography>

                                                ))}

                                            </TableCell>

                                            {/* QTY */}

                                            <TableCell align="center">

                                                {row.products?.map((p, i) => (

                                                    <Typography
                                                        key={i}
                                                        sx={{
                                                            fontSize: "0.8rem"
                                                        }}
                                                    >

                                                        {p.qty}

                                                    </Typography>

                                                ))}

                                            </TableCell>

                                            {/* TOTAL */}

                                            <TableCell>

                                                <Typography fontWeight="bold">

                                                    ₹ {row.totalAmount || totalSale}

                                                </Typography>

                                            </TableCell>

                                            {/* PAID */}

                                            <TableCell>

                                                <Typography
                                                    color="green"
                                                    fontWeight="bold"
                                                >

                                                    ₹ {row.paidAmount || 0}

                                                </Typography>

                                            </TableCell>

                                            {/* REMAINING */}

                                            <TableCell>

                                                <Typography
                                                    color={
                                                        (row.remainingAmount || 0) > 0
                                                            ? "error"
                                                            : "success"
                                                    }
                                                    fontWeight="bold"
                                                >

                                                    ₹ {row.remainingAmount || 0}

                                                </Typography>

                                            </TableCell>

                                            {/* DATE */}

                                            <TableCell>

                                                {row.grossDate
                                                    ? new Intl.DateTimeFormat(
                                                        "en-GB",
                                                        {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit"
                                                        }
                                                    ).format(
                                                        row.grossDate.toDate()
                                                    )
                                                    : "-"}

                                            </TableCell>

                                        </TableRow>

                                    );

                                })}

                        </TableBody>

                    </Table>

                </TableContainer>

                {/* PAGINATION */}

                <TablePagination
                    component="div"
                    count={filteredTrips.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) =>
                        setPage(newPage)
                    }
                    onRowsPerPageChange={(e) => {

                        setRowsPerPage(
                            parseInt(e.target.value, 10)
                        );

                        setPage(0);

                    }}
                />

            </Paper>

        </Box>

    );
}

export default Customertrips;